<template>
    <vPerformanceAssignmentComponent :postList="postList" v-if="flag"></vPerformanceAssignmentComponent>
</template>
<script>
import vPerformanceAssignmentComponent from '../../listComponent/basicdata/performance/performanceAssignmentComponent.vue';
export default {
    name: 'performance_assignment',
    components: {
        vPerformanceAssignmentComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                object_type_code: true,
                object_rid: true,
                object_number: true,
                date_range:true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>